<div class="row pb-2 row-height">
  <h1 class="col-12">Contact</h1>
  <div class="contentbox" *ngIf="!isPortal">
    <div class="col-12" [innerHtml]="linkContent | keepHtml"></div>
  </div>
  <!--PortalContent area-->
  <medpt-portal-feature-content [featureName]="'Contact'" *ngIf="isPortal" [showFullContentLink]="true"></medpt-portal-feature-content>
</div>
